"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChickenBondManager__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "bondNFTAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "lusdTokenAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "curvePoolAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "curveBasePoolAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "bammSPVaultAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "yearnCurveVaultAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "yearnRegistryAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "yearnGovernanceAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "bLUSDTokenAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "curveLiquidityGaugeAddress",
                        type: "address",
                    },
                ],
                internalType: "struct ChickenBondManager.ExternalAdresses",
                name: "_externalContractAddresses",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "targetAverageAgeSeconds",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "initialAccrualParameter",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "minimumAccrualParameter",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "accrualAdjustmentRate",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "accrualAdjustmentPeriodSeconds",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "chickenInAMMFee",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "curveDepositDydxThreshold",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "curveWithdrawalDxdyThreshold",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "bootstrapPeriodChickenIn",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "bootstrapPeriodRedeem",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "bootstrapPeriodShift",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "shifterDelay",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "shifterWindow",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "minBLUSDSupply",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "minBondAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "nftRandomnessDivisor",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "redemptionFeeBeta",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "redemptionFeeMinuteDecayFactor",
                        type: "uint256",
                    },
                ],
                internalType: "struct ChickenBondManager.Params",
                name: "_params",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "accrualParameter",
                type: "uint256",
            },
        ],
        name: "AccrualParameterUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "redeemer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bLusdAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "minLusdAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lusdAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "yTokens",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "redemptionFee",
                type: "uint256",
            },
        ],
        name: "BLUSDRedeemed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_baseRedemptionRate",
                type: "uint256",
            },
        ],
        name: "BaseRedemptionRateUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bonder",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bondId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "principalLusdAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "minLusdAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "withdrawnLusdAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint80",
                name: "bondFinalHalfDna",
                type: "uint80",
            },
        ],
        name: "BondCancelled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bonder",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bondId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lusdAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bLusdAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lusdSurplus",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "chickenInFeeAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "migration",
                type: "bool",
            },
            {
                indexed: false,
                internalType: "uint80",
                name: "bondFinalHalfDna",
                type: "uint80",
            },
        ],
        name: "BondClaimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "bonder",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bondId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint80",
                name: "bondInitialHalfDna",
                type: "uint80",
            },
        ],
        name: "BondCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_lastRedemptionFeeOpTime",
                type: "uint256",
            },
        ],
        name: "LastRedemptionTimeUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "previousPermanentLUSD",
                type: "uint256",
            },
        ],
        name: "MigrationTriggered",
        type: "event",
    },
    {
        inputs: [],
        name: "BETA",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "BOOTSTRAP_PERIOD_CHICKEN_IN",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "BOOTSTRAP_PERIOD_REDEEM",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "BOOTSTRAP_PERIOD_SHIFT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "CHICKEN_IN_AMM_FEE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DECIMAL_PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "INDEX_OF_LUSD_TOKEN_IN_CURVE_POOL",
        outputs: [
            {
                internalType: "int128",
                name: "",
                type: "int128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MINUTE_DECAY_FACTOR",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_BLUSD_SUPPLY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_BOND_AMOUNT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "NFT_RANDOMNESS_DIVISOR",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "SECONDS_IN_ONE_MINUTE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "SHIFTER_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "SHIFTER_WINDOW",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_bammLUSDValue",
                type: "uint256",
            },
        ],
        name: "_calcSystemBackingRatioFromBAMMValue",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accrualAdjustmentMultiplier",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accrualAdjustmentPeriodCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accrualAdjustmentPeriodSeconds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accrualParameter",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "activateMigration",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "bLUSDToken",
        outputs: [
            {
                internalType: "contract IBLUSDToken",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bammSPVault",
        outputs: [
            {
                internalType: "contract IBAMM",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseRedemptionRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bondNFT",
        outputs: [
            {
                internalType: "contract IBondNFT",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_bondID",
                type: "uint256",
            },
        ],
        name: "calcAccruedBLUSD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_bondID",
                type: "uint256",
            },
        ],
        name: "calcBondBLUSDCap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_fractionOfBLUSDToRedeem",
                type: "uint256",
            },
        ],
        name: "calcRedemptionFeePercentage",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "calcSystemBackingRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "calcTotalLUSDValue",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "calcTotalYearnCurveVaultShareValue",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "calcUpdatedAccrualParameter",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_bondID",
                type: "uint256",
            },
        ],
        name: "chickenIn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_bondID",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_minLUSD",
                type: "uint256",
            },
        ],
        name: "chickenOut",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "countChickenIn",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "countChickenOut",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_lusdAmount",
                type: "uint256",
            },
        ],
        name: "createBond",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "createBondWithPermit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "curveBasePool",
        outputs: [
            {
                internalType: "contract ICurvePool",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "curveDepositLUSD3CRVExchangeRateThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "curveLiquidityGauge",
        outputs: [
            {
                internalType: "contract ICurveLiquidityGaugeV5",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "curvePool",
        outputs: [
            {
                internalType: "contract ICurvePool",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "curveWithdrawal3CRVLUSDExchangeRateThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "deploymentTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "firstChickenInTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getAcquiredLUSDInCurve",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getAcquiredLUSDInSP",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBAMMLUSDDebt",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_bondID",
                type: "uint256",
            },
        ],
        name: "getBondData",
        outputs: [
            {
                internalType: "uint256",
                name: "lusdAmount",
                type: "uint256",
            },
            {
                internalType: "uint64",
                name: "claimedBLUSD",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "startTime",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "endTime",
                type: "uint64",
            },
            {
                internalType: "uint8",
                name: "status",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getLUSDInBAMMSPVault",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_bondID",
                type: "uint256",
            },
        ],
        name: "getLUSDToAcquire",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getOpenBondCount",
        outputs: [
            {
                internalType: "uint256",
                name: "openBondCount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getOwnedLUSDInCurve",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getOwnedLUSDInSP",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getPendingLUSD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getPermanentLUSD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getTotalAcquiredLUSD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getTotalLUSDInCurve",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getTreasury",
        outputs: [
            {
                internalType: "uint256",
                name: "_pendingLUSD",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_totalAcquiredLUSD",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_permanentLUSD",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastRedemptionTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastShifterCountdownStartTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lusdToken",
        outputs: [
            {
                internalType: "contract ILUSDToken",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "migration",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minimumAccrualParameter",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_bLUSDToRedeem",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_minLUSDFromBAMMSPVault",
                type: "uint256",
            },
        ],
        name: "redeem",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_lusdAmount",
                type: "uint256",
            },
        ],
        name: "sendFeeShare",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_maxLUSDToShift",
                type: "uint256",
            },
        ],
        name: "shiftLUSDFromCurveToSP",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_maxLUSDToShift",
                type: "uint256",
            },
        ],
        name: "shiftLUSDFromSPToCurve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "startShifterCountdown",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "targetAverageAgeSeconds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalWeightedStartTimes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "yTokensHeldByCBM",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "yearnCurveVault",
        outputs: [
            {
                internalType: "contract IYearnVault",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "yearnGovernanceAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "yearnRegistry",
        outputs: [
            {
                internalType: "contract IYearnRegistry",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class ChickenBondManager__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_externalContractAddresses, _params, overrides) {
        return super.deploy(_externalContractAddresses, _params, overrides || {});
    }
    getDeployTransaction(_externalContractAddresses, _params, overrides) {
        return super.getDeployTransaction(_externalContractAddresses, _params, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ChickenBondManager__factory = ChickenBondManager__factory;
ChickenBondManager__factory.bytecode = _bytecode;
ChickenBondManager__factory.abi = _abi;
